export default __webpack_public_path__ + "static/lingerieDrawing-f4776410d7182b0542ceb1c316ad15d9.svg";